import { formatPrice } from 'lib/utils/formatters';
import React from 'react';
import { Row, Col, InputGroup, InputGroupText, Input } from 'reactstrap';

interface ParkingFacility {
  id: string;
  property_id: string;
  facility_id: string;
  facility_type: string;
  facility_name: string;
  facility_value: number;
  createdAt: string;
  updatedAt: string;
  property_facilities: {
    id: string;
    facility_type: string;
    facility_name: string;
    createdAt: string;
    updatedAt: string;
  };
}

interface ParkingProps {
  parkingFacilities: ParkingFacility[];
}

const Parking: React.FC<ParkingProps> = ({ parkingFacilities }) => {
  if (!parkingFacilities || parkingFacilities.length === 0) {
    return (
      <div className="rounded p-4 text-center mb-1">
        <span className="text-muted">No Parking Available</span>
      </div>
    );
  }

  return (
    <div>
      <Row className="mb-2">
        <Col md={6}>
          <label className="form-label">Types of Parking</label>
        </Col>
        <Col md={6}>
          <label className="form-label">Parking Fee</label>
        </Col>
      </Row>
      {parkingFacilities.map((item, idx) => (
        <Row className="mb-3" key={idx}>
          <Col md={6}>
          <Input type="text" value={item.facility_name} readOnly />
          </Col>
          <Col md={6}>
            <InputGroup>
              <InputGroupText>$</InputGroupText>
              <Input type="text" value={formatPrice(item.facility_value)} readOnly />
            </InputGroup>
          </Col>
        </Row>
      ))}
    </div>
  );
};

export default Parking;